export const QUERY_KEYS = {
  ME: 'me',
  FEATURE_FLAGS: 'feature_flags',
  ALL_FEATURE_FLAGS: 'all_feature_flags',
  WHATS_NEW: 'whats_new',
  USER_WHATS_NEW: 'user_whats_new',
  WHATS_NEW_LATEST: 'whats_new_latest',
  ORGANIZATION: 'organization',
  SELECTED_APPLICATION: 'selected_application',
  USER_APPLICATIONS: 'user_applications',
  AVATARS: 'avatars',
  USER_AVATAR: 'user_avatar',
};
